<div class="login-signup-box popout" id="login-dialog-container">

  <button type="button" class="close circle-css" (click)="closeDialog()" aria-label="Close dialog">
    <span aria-hidden="true">&times;</span>
  </button>

  <div *ngIf="dialogData.isOtpLogin">
    <ic-otp-login></ic-otp-login>
  </div>
  <div *ngIf="!dialogData.isOtpLogin">
    <ul class="tabing-in-popup" role="tablist" aria-label="Authentication Options">
      <li role="presentation"><a [ngStyle]="selectedTab===1 ? clientConfig.style.bg : {}"
          role="tab" tabindex="0" [attr.aria-selected]="selectedTab===1" id="tab-login" aria-controls="panel-login"
          (click)="selectedTab=1" (keydown.enter)="selectedTab=1" (keydown.space)="selectedTab=1; $event.preventDefault()">Login</a>
      </li>
      <li role="presentation"><a [ngStyle]="selectedTab===2 ? clientConfig.style.bg : {}"
          role="tab" tabindex="0" [attr.aria-selected]="selectedTab===2" id="tab-signup" aria-controls="panel-signup"
          (click)="selectedTab=2" (keydown.enter)="selectedTab=2" (keydown.space)="selectedTab=2; $event.preventDefault()">Signup</a>
      </li>
    </ul>

    <div *ngIf="selectedTab === 1" id="panel-login" role="tabpanel" aria-labelledby="tab-login">
      <div class="login-signup-box popout">
        <div class="modal-body">
          <form [formGroup]="loginForm">
            <h3 id="login-modal-title" class="sr-only">Sign In to Your Account</h3>
            <p><strong>Enter your email and password to sign in</strong></p>
            <div class="form-group">
              <div class="text-box-wrap">
                <label for="loginUsername" class="sr-only">Email Address</label>
                <input type="email" id="loginUsername" formControlName="username" class="form-control" (keyup)="trimEmail()"
                  [ngClass]="{'is-invalid': formErrors.username}" placeholder="Email Address" maxlength="50"
                  autocomplete="email" aria-required="true"
                  [attr.aria-invalid]="fc.username.invalid && fc.username.touched"
                  [attr.aria-describedby]="fc.username.errors ? 'loginUsernameError' : null">
                <div *ngIf="fc.username.errors" id="loginUsernameError" class="invalid-feedback" role="alert">
                  <div *ngIf="fc.username.errors.required">
                    Please enter your Email Id
                  </div>
                  <div *ngIf="fc.username.errors.email">
                    Please enter valid Email Id.
                  </div>
                </div>
              </div>
            </div>
            <div class="form-group relative-class">
              <div class="text-box-wrap">
                <label for="loginPassword" class="sr-only">Password</label>
                <input [type]="showPassword ? 'text':'password'" id="loginPassword" formControlName="password" class="form-control"
                  [ngClass]="{'is-invalid': formErrors.password}" maxlength="50" placeholder="Password"
                  autocomplete="current-password" aria-required="true"
                  [attr.aria-invalid]="fc.password.invalid && fc.password.touched"
                  [attr.aria-describedby]="fc.password.errors ? 'loginPasswordError' : null">
                <button type="button" class="btn-password-toggle" (click)="showPassword = !showPassword"
                  [attr.aria-label]="showPassword ? 'Hide password' : 'Show password'">
                  <i [ngClass]="showPassword ? 'fa fa-eye' : 'fa fa-eye-slash'" aria-hidden="true"></i>
                </button>
                <div *ngIf="fc.password.errors" id="loginPasswordError" class="invalid-feedback" role="alert">
                  <div *ngIf="fc.password.errors.required">
                    Please enter your Password
                  </div>
                </div>
              </div>
            </div>

            <div class="form-group">
              <button type="button" [disabled]="!loginForm.valid" [ngStyle]="clientConfig.style.bg" (click)="login()"
                class="app-btn btn btn-danger btn-block">Login</button>
            </div>
          </form>
        </div>
      </div>
      <button type="button" class="fplink" (click)="selectedTab=3">Forgot password</button>
      <a routerLink="/auth/deactivate" class="fplink" (click)="closeDialog()">Deactivate account</a>
    </div>

    <div *ngIf="selectedTab === 2" id="panel-signup" role="tabpanel" aria-labelledby="tab-signup">
      <ic-sign-up></ic-sign-up>
    </div>

    <div *ngIf="selectedTab === 3" id="panel-forgot" role="tabpanel" aria-label="Forgot Password">
      <ic-forgot-password></ic-forgot-password>
    </div>
  </div>
</div>